const CheckList = `
  date
  id  
  location
  technician
  typeId
`;

export default CheckList;
